import numberMixin from "@/mixins/numberMixin";

const inCents = value => numberMixin.methods.currencyInCents(value);

function buildTransferRequestBody(payload) {
  return {
    data: {
      type: "transfers",
      attributes: {
        amount: inCents(payload.amount),
        description: payload.description
      },
      relationships: {
        payment_gateway_account: {
          data: {
            type: "payment_gateway_account",
            id: payload.payer.id
          }
        },
        channel: {
          data: {
            type: payload.receiver.type,
            id: payload.receiver.id
          }
        }
      }
    }
  };
}

export default { buildTransferRequestBody };



// WEBPACK FOOTER //
// ./src/API/helpers/transfers.js